module.exports = __webpack_public_path__ + "img/foto-time-de-donos.657d28ac.jpg";